
    import './styles.scoped.css';
    export default {
  "button-trigger": "awsui_button-trigger_18eso_7pgwp_101",
  "arrow": "awsui_arrow_18eso_7pgwp_101",
  "has-caret": "awsui_has-caret_18eso_7pgwp_168",
  "placeholder": "awsui_placeholder_18eso_7pgwp_171",
  "pressed": "awsui_pressed_18eso_7pgwp_184",
  "disabled": "awsui_disabled_18eso_7pgwp_187",
  "in-filtering-token": "awsui_in-filtering-token_18eso_7pgwp_197",
  "read-only": "awsui_read-only_18eso_7pgwp_203",
  "invalid": "awsui_invalid_18eso_7pgwp_225",
  "warning": "awsui_warning_18eso_7pgwp_236",
  "inline-tokens": "awsui_inline-tokens_18eso_7pgwp_274"
};
  